import React, { useEffect, useState } from "react";
import SearchProject from "../../assets/SearchProject.svg";
import AddProjectModal from "./AddProjectModal";
import { useDispatch } from "react-redux";
import { selectProject } from "../../redux/actions/projectActions";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { apiClient } from "../../services/api/apiClient";

function ProjectSelection({ isSidebarOpen, toggleSidebar }) {
  const [projectsData, setProjectsData] = useState([]);
  const [isAddProjectOpen, setISAddProjectOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        console.log('ProjectSelection: Starting to fetch projects...');
        const response = await apiClient.get("/projects"); // Use authenticated API client
        console.log('ProjectSelection: Projects fetched successfully:', response);
        // Extract data from the structured response
        setProjectsData(response.data || []); // Update state with fetched data
      } catch (error) {
        console.error("ProjectSelection: Error fetching project data:", error);
        console.error("ProjectSelection: Error details:", {
          message: error.message,
          stack: error.stack
        });
      }
    };

    fetchProjects();
  }, []); // Empty dependency array to only run on mount

  const openAddProject = () => {
    setISAddProjectOpen(true);
  };
  const closeAddProject = () => {
    setISAddProjectOpen(false);
  };
  const handleAddProject = async (newProjectData) => {
    try {
      const response = await apiClient.post("/projects", newProjectData); // Use authenticated API client
      const addedProject = response.data; // Extract data from structured response

      setProjectsData((prevProjectsData) => [
        ...prevProjectsData,
        addedProject,
      ]); // Add new project to the list

      // Automatically select the newly created project
      dispatch(selectProject(addedProject.id));

      // Close the sidebar after successfully creating the project
      if (isSidebarOpen) {
        toggleSidebar();
      }

      closeAddProject();
    } catch (error) {
      console.error("Error adding project:", error);
      // Optionally, display an error message to the user
      throw error; // Re-throw the error to be caught by AddProjectModal
    }
  };

  // Filter projects based on search term (searches both job name and job number)
  const filteredProjects = projectsData.filter(
    (project) =>
      project.job_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      project.job_number.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleProjectClick = (projectId) => {
    dispatch(selectProject(projectId));
  };

  return (
    <>
      <main className="flex flex-col py-8 mx-auto w-full max-w-[720px] bg-gray-100 rounded-xl h-screen">
        {/* Header Section */}
        <header className="flex flex-col px-4 pb-5 w-full border-b">
          <div className="flex justify-between items-center">
            <h1 className="text-lg text-gray-900 font-semibold">
              Select Project
            </h1>
            <button
              className="px-4 py-2 text-sm leading-none text-center text-white bg-indigo-600 rounded-md shadow-md"
              onClick={openAddProject}
            >
              Add New Project
            </button>
          </div>
          <div className="flex mt-3 w-full rounded-md bg-white shadow-md">
            <div className="relative flex-1">
              <input
                type="text"
                placeholder="Search projects by name or number..."
                className="w-full py-2 pl-10 pr-3 text-base text-black bg-white rounded-md"
                aria-label="Search projects"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <div className="absolute top-0 left-0 flex items-center pl-3 h-full">
                <img loading="lazy" src={SearchProject} alt="Search" />
              </div>
            </div>
          </div>
        </header>

        {/* Project List with Scrollbar */}
        <section className="flex-1 mt-3 w-full space-y-4 overflow-y-auto pb-4">
          {filteredProjects.map((project) => (
            <article
              key={project.id}
              className="flex w-full rounded-md bg-white shadow-md overflow-hidden min-h-[100px]  cursor-pointer"
              onClick={() => {
                handleProjectClick(project.id);
                if (isSidebarOpen) {
                  toggleSidebar();
                }
              }}
            >
              <div className="flex justify-center items-center px-4 py-5 w-20 bg-slate-400">
                <img
                  loading="lazy"
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/8e55deff970ca50f96b1213712e0a9535b956620ea9f3e733d1865c1873c5a3d?placeholderIfAbsent=true&apiKey=a18dbcc5f1294887aa16ecf9b3731919"
                  alt="Project"
                  className="object-contain w-12"
                />
              </div>
              <div className="flex flex-1 justify-between items-center p-4 bg-white">
                <div className="flex flex-col">
                  <h2 className="font-medium text-gray-900 text-base">
                    {project.job_name}
                  </h2>
                  <p className="text-gray-500 text-sm">{project.job_number}</p>
                </div>
                <div className="flex items-center">
                  <ChevronRightIcon className="w-6 h-6 text-gray-500" />
                </div>
              </div>
            </article>
          ))}
        </section>
      </main>

      <AddProjectModal
        isOpen={isAddProjectOpen}
        onClose={closeAddProject}
        onSubmit={handleAddProject}
      />
    </>
  );
}

export default ProjectSelection;
